import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const cartIsValidForPostingOnlineOrder = createSelector(cartState, (cart) => cart?.itemsSimple?.length > 0 || cart?.itemsMenuFlow?.length > 0);
